module.exports = __webpack_public_path__ + "static/media/201it102.b6f045f5.jpg";